import { render } from "./Step2.vue?vue&type=template&id=4d0a6dc2&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"

import "./Step2.vue?vue&type=style&index=0&id=4d0a6dc2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d0a6dc2"

export default script